import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type StoredScheduleZoom = 'today' | 'day' | 'week' | 'month' | 'year';
export type StoredScheduleLens = 'calendar' | 'crew' | 'route';

interface ScheduleViewState {
  resolved: { zoom: StoredScheduleZoom; lens: StoredScheduleLens } | null;
  lastFetched: number | null;
  setCache: (v: { zoom: StoredScheduleZoom; lens: StoredScheduleLens }) => void;
  clear: () => void;
}

export const useScheduleViewStore = create<ScheduleViewState>()(
  persist(
    (set) => ({
      resolved: null,
      lastFetched: null,
      setCache: (v) => set({ resolved: v, lastFetched: Date.now() }),
      clear: () => set({ resolved: null, lastFetched: null }),
    }),
    {
      name: 'crewbit-schedule-view-v1',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        resolved: state.resolved,
        lastFetched: state.lastFetched,
      }),
    },
  ),
);
